import { render, staticRenderFns } from "./SidebarSectionSettings.vue?vue&type=template&id=5d0a3e78&"
import script from "./SidebarSectionSettings.vue?vue&type=script&lang=js&"
export * from "./SidebarSectionSettings.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSectionSettings.vue?vue&type=style&index=0&id=5d0a3e78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports